import { ApiError } from './api-client'

/**
 * Maps a failure from the API into an i18n key. Written as its own function
 * because the views used to blame the network for everything, which sent us
 * hunting a connectivity problem while the backend was returning 500.
 */
export function apiErrorMessageKey(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return 'auth.sessionExpired'
    if (error.status === 403) return 'errors.unauthorized'
    if (error.status === 404) return 'errors.notFound'
    if (error.status === 409) return 'errors.alreadySaved'
    // The playlist moved under us — usually another device, or the resolver.
    if (error.status === 412) return 'errors.changedElsewhere'
    if (error.status === 415) return 'errors.badRequest'
    if (error.status >= 500) return 'errors.server'
    return 'errors.generic'
  }
  // `fetch` rejects with a TypeError for DNS, CORS, offline and CSP failures.
  if (error instanceof TypeError) return 'errors.network'
  return 'errors.generic'
}

/** True when the stored session is unusable and the user must sign in again. */
export function isSessionExpired(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401
}
